import type { LinkProps } from "@tanstack/react-router";
import type { ElementType } from "react";
import {
  LayoutDashboard,
  Menu,
  Plus,
  Receipt,
  Truck,
} from "@/components/icons";
import type { PermissionId } from "@/modules/roles/domain/contracts/permissions";

export type BottomNavLink = {
  id: string;
  title: string;
  url: LinkProps["to"] | (string & {});
  icon: ElementType;
  requiredPermissions?: PermissionId[];
  /** Match path prefix (e.g. /app/fulfillment/*). Default: exact path. */
  matchPrefix?: boolean;
  /** Paths under the same prefix that should NOT activate this item. */
  excludePaths?: string[];
};

export type BottomNavMore = {
  id: "more";
  title: string;
  icon: ElementType;
  action: "open-sidebar";
};

export type BottomNavItem = BottomNavLink | BottomNavMore;

/** Primary destinations for solo-merchant mobile use (Facebook chat + pack). */
export const bottomNavItems: BottomNavItem[] = [
  {
    id: "dashboard",
    title: "ໜ້າຫຼັກ",
    url: "/app/dashboard",
    icon: LayoutDashboard,
  },
  {
    id: "orders",
    title: "ອໍເດີ້",
    url: "/app/orders",
    icon: Receipt,
    requiredPermissions: ["orders:read"],
    matchPrefix: true,
    excludePaths: ["/app/orders/new"],
  },
  {
    id: "new-order",
    title: "ສ້າງ",
    url: "/app/orders/new",
    icon: Plus,
    requiredPermissions: ["orders:write"],
  },
  {
    id: "fulfillment",
    title: "ຈັດສົ່ງ",
    url: "/app/fulfillment",
    icon: Truck,
    requiredPermissions: ["orders:read"],
    matchPrefix: true,
  },
  {
    id: "more",
    title: "ເພີ່ມ",
    icon: Menu,
    action: "open-sidebar",
  },
];
